import { DialogComponent } from '@theme/dialog';

/**
 * Size Guide Drawer
 * - Opens/closes as a right-side drawer (inherits dialog behaviors)
 * - Handles IN/CM unit toggle by showing the corresponding table
 */
class SizeGuideDrawer extends DialogComponent {
  connectedCallback() {
    super.connectedCallback();
    // Default unit state is IN
    this.unit = 'IN';

    // Prevent default form button behavior in case of nested forms
    this.addEventListener('submit', (e) => e.preventDefault());
  }

  open() {
    this.showDialog();
    
    // Override default focus behavior - focus the dialog itself instead of close button
    requestAnimationFrame(() => {
      const { dialog } = this.refs;
      if (dialog) {
        dialog.focus();
      }
    });
  }

  close() {
    this.closeDialog();
  }

  /**
   * Sets current unit and toggles visible table
   * @param {{ unit: 'IN' | 'CM' }} data
   */
  setUnit(data) {
    const unit = typeof data === 'string' ? data : data?.unit;
    if (unit !== 'IN' && unit !== 'CM') return;
    this.unit = unit;

    const tables = this.querySelectorAll('.size-guide__table');
    tables.forEach((el) => {
      el.toggleAttribute('hidden', el.getAttribute('data-unit') !== unit);
    });

    const buttons = this.querySelectorAll('.size-guide__unit-btn');
    buttons.forEach((btn) => {
      const isActive = btn.textContent?.trim().toUpperCase() === unit;
      btn.classList.toggle('is-active', isActive);
      btn.setAttribute('aria-pressed', String(isActive));
    });
  }
}

if (!customElements.get('size-guide-drawer')) {
  customElements.define('size-guide-drawer', SizeGuideDrawer);
}


